import { formatInTimeZone } from 'date-fns-tz';
import { getDefaultFormats } from './DateUtils2.js';

const getIsoDateTime = (date, dateOnly = false) => {
    if (!date)
        return undefined;
    const { isoFormat, timezone } = getDefaultFormats();
    if (dateOnly)
        return formatInTimeZone(date, timezone, 'yyyy-MM-dd');
    if (isoFormat === 'iso-tz-offset')
        return formatInTimeZone(date, timezone, 'yyyy-MM-dd"T"HH:mm:ssXX');
    else
        return date.toISOString();
};

export { getIsoDateTime };
